import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_evaluate_exposure_to_concentrations_of_airborne_pa'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_evaluate_exposure_to_concentrations_of_airborne_pa',
  name: 'Does the facility evaluate exposure to concentrations of airborne particulates (dust/ fibers/ mists /fumes) in line with legal requirements?',
  description:
    'There may be applicable legislation addressing the risk assessment of worker exposure to hazardous airborne particulates. Examples are laws requiring employers to limit worker exposures to hazardous particulates (e.g. silica, wood dust, etc.).  Examples are laws requiring compliance with permissible exposure levels (concentrations and duration).  Exposures must evaluated against these permissible exposure levels via sampling, modeling, or other means of risk assessment.  \r\r\n\r\r\nNote that the intent of this question is not to indicated whether there is the general presence of airborne particulates. The intent of this question is to determine if the facility is evaluating the potential and/ or real hazards of hazardous airborne particulates in line with legal requirements. \r\r\n\r\r\nFumes are small heated particles formed when a volatilized solid (e.g. metal) condenses in cooler air. Fibers are solid particles with its length several times greater than its width (Asbestos is an example of a fiber). Mists are liquid droplets of a substance or mixture suspended in a gas (usually air).\r\r\n\r\r\nConsult applicable legal requirements. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-gen-17',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13360,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
